import { Component, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ChangePasswordNotifierService } from '@utils/services/re-new-password.service';
import { SessionService } from '@utils/services/session.service';
import { SideBarService } from '@shared/UI/elements-ui/sidebar/sidebar.service';
import { CommonModule } from '@angular/common';
import { LogicalGrowthComponentsModule } from '@app/logical-growth-components/logical-growth-components.module';
import { IfPermissionsDirective } from '@shared/directives/if-permissions.directive';
import { resolveUserProfile } from '@utils/user-profile.util';

@Component({
  selector: 'navbar-profile',
  standalone: true,
  imports: [CommonModule, LogicalGrowthComponentsModule, IfPermissionsDirective],
  templateUrl: './navbar-profile.component.html',
  styleUrls: ['./navbar-profile.component.scss']
})
export class NavbarProfileComponent {

  public isOpen = signal<boolean>(false);
  public user = computed(() => this._sessionService.user ?? null);
  public userProfile = computed(() => resolveUserProfile(this.user()));
  private readonly _router = inject(Router);
  private readonly _sideBarService = inject(SideBarService);
  private readonly _passwordNotifier = inject(ChangePasswordNotifierService);
  private readonly _sessionService = inject(SessionService);

  public toggleOpenStatus(current: boolean): void {
    this.isOpen.set(!current);
  }

  public logOut(): void {
    if (this.user()?.need_password_renew === true) {
      this._passwordNotifier.notifyPassword = true;
    }
    this._sessionService.clear();
    this._router.navigateByUrl('/');
    this.toggleOpenStatus(this.isOpen());
    if (this._sideBarService.isOpen()) {
      this._sideBarService.setClosed();
    }
  }

  public navigateToOption(url: string): void {
    this.toggleOpenStatus(this.isOpen());
    this._sideBarService.clearOptions();
    this._router.navigateByUrl(url);
  }
}
